import React, { ReactNode, createContext, useContext, useState } from "react";

export type ComingSoonAlertType = {
    make: string;
    model: string;
    colour: string;
    stockNo: string;
};

type AlertContextType = {
    alert: ComingSoonAlertType | null;
    setAlert: (alert: ComingSoonAlertType) => void;
};

const ComingSoonAlertContext = createContext<AlertContextType | undefined>(undefined);

interface AlertProviderProps {
    children: ReactNode;
}

export const ComingSoonAlertProvider: React.FC<AlertProviderProps> = ({ children }) => {
    const [alert, setComingSoonAlert] = useState<ComingSoonAlertType | null>(null);

    const setAlert = (v: ComingSoonAlertType) => {
        setComingSoonAlert(v);
    };

    return (
        <ComingSoonAlertContext.Provider value={{ alert, setAlert }}>
            {children}
        </ComingSoonAlertContext.Provider>
    );
};

export const useComingSoonAlert = (): AlertContextType => {
    const context = useContext(ComingSoonAlertContext);
    if (!context) {
        throw new Error("useComingSoonAlert must be used within an ComingSoonAlertProvider");
    }
    return context;
};
